import { Navigate, Outlet, Route, Routes, useParams } from "react-router-dom"
import { AuthLayout } from "./components/AuthLayout"
import { GuestLayout } from "./components/GuestLayout"
import { AttivazioneAccount } from "./pages/Account/AttivazioneAccount"
import { Login } from "./pages/Account/Login"
import { PasswordDimenticata } from "./pages/Account/PasswordDimenticata"
import { ResetPassword } from "./pages/Account/ResetPassword"
import Produttore from "./pages/Produttore"
import Produttori from "./pages/Produttori"
import Utenti from "./pages/Utenti"
import Vocabolari from "./pages/Vocabolari"
import Fondi from "./pages/Fondi"
import Fondo from "./pages/Fondo/Fondo"
import Donatori from "./pages/Donatori"
import Persone from "./pages/Persone"
import Luoghi from "./pages/Luoghi"
import Enti from "./pages/Enti"
import DonatoreDettaglio from "./pages/Donatore"
import PersonaDettaglio from "./pages/Persona"
import Tags from "./pages/Tags"
import Supporti from "./pages/Supporti"
import SupportoDettaglio from "./pages/Supporto/Supporto"
import Formati from "./pages/Formati"
import Documenti from "./pages/Documenti"
import DocumentiDettaglio from "./pages/Documento/Documento"
import FilesDigitali from "./pages/FilesDigitali"
import FileDigitaleDettaglio from "./pages/FileDigitale/FileDigitale"
import Vocaboli from "./pages/Vocaboli"
import Profilo from "./pages/Profilo"
import SequenzeList from "./pages/SequenzeList"
import Ricerca from "./pages/Ricerca/Ricerca"
import { useTranslation } from "react-i18next"
import About from "./pages/About"
import Assemblaggi from "./pages/Assemblaggi"
import Assemblaggio from "./pages/Assemblaggio/Assemblaggio"

const LANGS = ["it", "en"]

export function NotFound() {
  return <div>Not Found</div>
}

function AvailablesLang() {
  const { lang } = useParams()
  if (LANGS.includes(lang!)) {
    return <Outlet />
  }
  return <NotFound />
}

export function Navigation() {
  const { i18n } = useTranslation()

  return (
    <Routes>
      <Route path="/" element={<AuthLayout redirect_to="/login" />}>
        <Route index element={<Navigate to={`/${i18n.language}/fondi`} />} />
        <Route path={":lang/*"} element={<AvailablesLang />}>
          <Route path="produttori/:id" element={<Produttore />} />
          <Route path="produttori" element={<Produttori />} />
          <Route path="fondi/:id/*" element={<Fondo />} />
          <Route path="fondi" element={<Fondi />} />
          <Route path="utenti" element={<Utenti />} />
          <Route path="vocabolari" element={<Vocabolari />} />
          <Route path="vocaboli" element={<Vocaboli />} />
          <Route path="donatori" element={<Donatori />} />
          <Route path="donatori/:id" element={<DonatoreDettaglio />} />
          <Route path="persone" element={<Persone />} />
          <Route path="persone/:id" element={<PersonaDettaglio />} />
          <Route path="luoghi" element={<Luoghi />} />
          <Route path="enti" element={<Enti />} />
          <Route path="tags" element={<Tags />} />
          <Route path="supporti" element={<Supporti />} />
          <Route path="supporti/:supportoId/*" element={<SupportoDettaglio />} />
          <Route path="formati" element={<Formati />} />
          <Route path="documenti" element={<Documenti />} />
          <Route path="documenti/:id/*" element={<DocumentiDettaglio />} />
          <Route path="files" element={<FilesDigitali />} />
          <Route path="files/:fileDigitaleId/*" element={<FileDigitaleDettaglio />} />
          <Route path="profilo" element={<Profilo />} />
          <Route path="sequenze" element={<SequenzeList />} />
          <Route path="assemblaggi" element={<Assemblaggi />} />
          <Route path="assemblaggi/:id/*" element={<Assemblaggio />} />
          <Route path="ricerca/*" element={<Ricerca />} />
          <Route path="about" element={<About />} />
        </Route>

        {/* <Route path="profilo" element={<Profilo />} /> */}
      </Route>
      <Route path="/login" element={<GuestLayout redirect_to="/" />}>
        <Route index element={<Login />}></Route>
      </Route>
      <Route path="/password-dimenticata" element={<GuestLayout redirect_to="/" />}>
        <Route index element={<PasswordDimenticata />}></Route>
      </Route>
      <Route path="/reset-password" element={<GuestLayout redirect_to="/" />}>
        <Route index element={<ResetPassword />}></Route>
      </Route>
      <Route path="/attivazione-account" element={<GuestLayout redirect_to="/" />}>
        <Route index element={<AttivazioneAccount />}></Route>
      </Route>
    </Routes>
  )
}
